import AbstractHover from '../../utils/AbstractHover';
import { Trans } from 'react-i18next';
import css from '../seat-map.module.css';
import PropTypes from 'prop-types';
import React from 'react';

export default class HoverSeat extends AbstractHover {
    renderTitle() {
        return (
            <span className={css['popover-title']}>
                <span>
                    <Trans i18nKey="ticket.attendees.import.errors.details.seat_seat" />
                    &nbsp;
                    {this.props.zone.seat}
                </span>
                <li></li>
                <span>
                    <Trans i18nKey="ticket.attendees.import.errors.details.seat_row" />
                    &nbsp;
                    {this.props.zone.row}
                </span>
                <li></li>
                <span>
                    <Trans i18nKey="ticket.attendees.import.errors.details.seat_access" />
                    &nbsp;
                    {this.props.zone.access}
                </span>
            </span>
        );
    }

    renderPriceText(seat, prices, form, categories) {
        const color = categories.filter(category => seat.category === category.uuid);
        const { default_language, currency } = form;
        const currencyOutput = Intl.NumberFormat(default_language, {
            style: 'currency',
            currency: currency
        });
        if (seat.booking_state !== 'AVAILABLE') {
            return (
                <span className={css['popover-title']}>
                    <li style={{ color: '#000000' }}></li>
                    <Trans i18nKey="attendees.addAttendees.withSeats.seatMap.unavailable" values={{ rate: currencyOutput.format(prices.sort()[0]) }} />
                </span>
            );
        }

        return (
            <span className={css['popover-title']}>
                <li style={{ color: color[0]?.color ? color[0]?.color : '#FFF', fontSize: '30px' }}></li>
                <Trans i18nKey="fromRate" values={{ rate: currencyOutput.format(prices.sort()[0]) }} />
            </span>
        );
    }

    renderCategories(zone, categories, form) {
        let prices = [];
        categories
            .filter(category => zone.category === category.uuid)
            .forEach(cat => {
                cat.rates.forEach(rate => {
                    let price = rate.price;
                    if (price instanceof String) {
                        price = parseFloat(rate.price.replace(',', '.'));
                    }
                    prices.push(price);
                });
            });

        return (
            <li
                key={zone.uuid}
                className="category modal-popup-category"
                data-id={zone.uuid}
                style={{ display: 'flex', padding: '10px 10px 10px 0', marginLeft: '-10px', justifyContent: 'flex-start' }}
            >
                <span>
                    <div className="category-icon" style={{ backgroundColor: '#235467' }} />
                    <div className="name">{zone.name}</div>
                </span>
                <div>{this.renderPriceText(zone, prices, form, categories)}</div>
            </li>
        );
    }

    renderContent() {
        let { zone, categories, form } = this.props;

        return (
            <div>
                <div className="category">{this.renderCategories(zone, categories, form)}</div>
            </div>
        );
    }
}

HoverSeat.propTypes = {
    zone: PropTypes.object.isRequired,
    categories: PropTypes.object.isRequired
};
